export type RoleType =
  | "user"
  | "admin"
  | "editor"
  | "assessor"
  | "area_head"
  | "ei_expert"
  | "group_hse"
  | "super_user"
  | "zone_owner"
  | "field_editor"
  | "unit_manager"
  | "site_manager"
  | "lead_assesor"
  | "country_admin"
  | "action_assignee"
  | "country_hsc_head"
  | "country_env_head"
  | "group_security_expert"
  | "country_security_expert";

export type RoleName =
  | "User"
  | "Admin"
  | "Editor"
  | "Assessor"
  | "Area Head"
  | "Ei Expert"
  | "Group HSE"
  | "Super user"
  | "Zone Owner"
  | "Field Editor"
  | "Unit Manager"
  | "Site Manager"
  | "Country admin"
  | "Assessor Lead"
  | "Action Assignee"
  | "Country ENV Head"
  | "Country HSE Head"
  | "Group Security Expert"
  | "Country Security Expert";

export interface RoleAccessModel {
  assetEdition: boolean;
  actionClosure: boolean;
  actionEdition: boolean;
  assetApprover: boolean;
  assetCreation: boolean;
  assignAssessor: boolean;
  findingEdition: boolean;
  findingClosure: boolean;
  actionCreation: boolean;
  assignUnitAdmin: boolean;
  findingCreation: boolean;
  assessmentEdition: boolean;
  assignUnitManager: boolean;
  submitForApproval: boolean;
  performanceEditor: boolean;
  performanceApprover: boolean;
  assessmentApprover: boolean;
  assessmentCreation: boolean;
  assignCountryAdmin: boolean;
  mmInventoryEdition: boolean;
  mmInventoryApprover: boolean;
  assignCountryHSEHead: boolean;
  assignActionAssignee: boolean;
  assignInventoryCreator: boolean;
}

export enum RoleTypeEnum {
  User = "user",
  Admin = "admin",
  Assessor = "assessor",
  AreaHead = "area_head",
  MMExpert = "mm_expert",
  GroupHSE = "group_hse",
  SuperUser = "super_user",
  UnitAdmin = "unit_admin",
  UnitManager = "unit_manager",
  SiteManager = "site_manager",
  editor = "inventory_creator",
  CountryAdmin = "country_admin",
  ActionAssignee = "action_assignee",
  CountryHSEHead = "country_hse_head",
  GroupSecurityExpert = "group_security_expert",
  CountrySecurityExpert = "country_security_expert",
}

export enum RoleNameEnum {
  User = "User",
  AreaHead = "area_head",
  MMExpert = "MM Expert",
  GroupHSE = "Group HSE",
  SiteAdmin = "Site Admin",
  UnitAdmin = "Unit Admin",
  SuperUser = "Super Admin",
  UnitManager = "Unit Manager",
  editor = "Inventory Creator",
  CountryAdmin = "Country Admin",
  Assessor = "Assessor (Inspector)",
  ActionAssignee = "Action Assignee",
  CountryHSEHead = "Country HSE Head",
  GroupSecurityExpert = "Group Security Expert",
  CountrySecurityExpert = "Country Security Expert",
}

export enum RoleAccessEnum {
  AssetEdition = "assetEdition",
  ActionClosure = "actionClosure",
  ActionEdition = "actionEdition",
  AssetApprover = "assetApprover",
  AssetCreation = "assetCreation",
  AssignAssessor = "assignAssessor",
  FindingEdition = "findingEdition",
  FindingClosure = "findingClosure",
  ActionCreation = "actionCreation",
  AssignUnitAdmin = "assignUnitAdmin",
  FindingCreation = "findingCreation",
  AssessmentEdition = "assessmentEdition",
  AssignUnitManager = "assignUnitManager",
  SubmitForApproval = "submitForApproval",
  AssessmentApprover = "assessmentApprover",
  AssessmentCreation = "assessmentCreation",
  AssignCountryAdmin = "assignCountryAdmin",
  AssignCountryHSEHead = "assignCountryHSEHead",
  AssignActionAssignee = "assignActionAssignee",
  AssignInventoryCreator = "assignInventoryCreator",
}
export enum RolesCategoryEnum {
  AdminRole = "admin",
  FlowRole = "flow_role",
  ViewerRole = "viewer_role",
  DerivedRole = "derived_role",
}
export interface RoleObject {
  role?: string;
  name?: string;
}

export interface UserModel {
  roles?: string | RoleObject | (string | RoleObject)[];
}
export interface FirestoreTimestampLike {
  toDate: () => Date;
}
export interface RoleModel {
  roleType: string;
  locationId?: string;
  role: RoleType | string;
  access: RoleAccessModel;
  name: RoleName | string;
  permissions: RoleModuleAccessModel[]; // base permissions tree
  extraPermissions?: RoleExtraPermissionModel[]; // optional overrides //! Will implement letter
}

export interface RoleMasterModel {
  id: string;
  roleType: string;
  role: RoleType | string;
  access: RoleAccessModel;
  name: RoleName | string;
  permissions?: RoleModuleAccessModel[]; // base permissions tree
  extraPermissions?: RoleExtraPermissionModel[]; // optional overrides //! Will implement letter
}

export interface RoleModuleAccessModel {
  moduleId: string;
  moduleName?: string;
  parentId?: string;
  access: RoleMasterAccessListModel;
  submodules: RoleModuleAccessModel[];
}

// export interface RoleSubModuleAccessModel {
//   moduleId: string;
//   moduleName: string;
//   access: RoleMasterAccessListModel;
//   submodules?: RoleSubModuleAccessModel[];
// }
export interface RoleMasterAccessListModel {
  view: boolean;
  edit: boolean;
  delete: boolean;
  create: boolean;
  export: boolean;
  approval: boolean;
  assignee: boolean;
}

// Role-specific extra permissions (patches to base role permissions)
export interface RoleExtraPermissionModel {
  moduleName: string;
  subModuleName?: string;
  access: Partial<RoleMasterAccessListModel>;
}

export interface AddUpdateRoleMasterResponse {
  status: boolean;
  message: string;
  data: RoleMasterModel;
}
